module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-expansion-panel', {
    key: "itemKey",
    attrs: {
      "value": _vm.lazyVal
    }
  }, [_c('v-expansion-panel-header', [_vm._v(" " + _vm._s(_vm.headline) + " ")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-card', [_c('v-card-text', [_c('span', [_vm._v(_vm._s(_vm.text))]), _vm._v(" "), _c('v-autocomplete', {
    attrs: {
      "item-text": _vm.itemText,
      "item-value": _vm.itemValue,
      "loading": _vm.loading,
      "search-input": _vm.search,
      "items": _vm.items,
      "placeholder": "enter the name to start search",
      "return-object": ""
    },
    on: {
      "update:searchInput": function($event) {
        _vm.search = $event
      },
      "update:search-input": function($event) {
        _vm.search = $event
      },
      "input": function (val) {
        var _obj;

        return _vm.$emit('input', ( _obj = {}, _obj[_vm.type] = _vm.lazyVal[_vm.itemValue], _obj ));
  }
    },
    model: {
      value: (_vm.lazyVal),
      callback: function($$v) {
        _vm.lazyVal = $$v
      },
      expression: "lazyVal"
    }
  }), _vm._v(" "), (_vm.lazyVal) ? _c('v-expand-transition', [_c('v-list', [_c('v-list-item', _vm._l((_vm.fields), function(field, index) {
    return _c('v-list-item-content', {
      key: index
    }, [_c('v-list-item-title', [_vm._v(_vm._s(field))]), _vm._v(" "), _c('v-list-item-subtitle', [_vm._v(_vm._s(_vm.lazyVal[field]))])], 1)
  }), 1)], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /export/jenkins/workspace/stage-isrs-frontend-mb_master/~/vue-loader/lib/template-compiler?{"id":"data-v-5d85becb"}!/export/jenkins/workspace/stage-isrs-frontend-mb_master/~/vue-loader/lib/selector.js?type=template&index=0!./client/components/IsrsPncTypeCard.vue
// module id = 939
// module chunks = 1